import { Page, SyncWriteResponse, V3AbsenceValuationMethod } from '@crewmeister/shared/src/types';
import { applyMinimalChangesToArray } from '@crewmeister/shared/src/utils/array';
import { applyWriteResponsesToArray } from '@crewmeister/shared/src/utils/v3';
import produce from 'immer';
import { AnyAction } from 'redux';
import { ACTION_NAMES } from '../../constants';

type V3AbsenceValuationMethodLoadAction = {
  type: string;
  result: Page<V3AbsenceValuationMethod>;
};

type V3AbsenceValuationMethodPatchAction = {
  type: string;
  result: { body: SyncWriteResponse<V3AbsenceValuationMethod, number> }[];
};

type V3AbsenceValuationMethodSliceInRedux = { absenceValuationMethods: V3AbsenceValuationMethod[] };

const initialState = { absenceValuationMethods: [] } as V3AbsenceValuationMethodSliceInRedux;

export const v3AbsenceValuationMethodReducer = (
  state = initialState,
  action: AnyAction & V3AbsenceValuationMethodLoadAction & V3AbsenceValuationMethodPatchAction
): V3AbsenceValuationMethodSliceInRedux =>
  produce(state, (draft: V3AbsenceValuationMethodSliceInRedux) => {
    switch (action.type) {
      case `${ACTION_NAMES.V3_LOAD_ABSENCE_VALUATION_METHOD}_SUCCESS`:
        applyMinimalChangesToArray(
          draft.absenceValuationMethods,
          action.result.content,
          (element) => element.crewId === action.crewId || element.crewId === null
        );
        break;
      case `${ACTION_NAMES.V3_ABSENCE_VALUATION_METHOD_PATCH}_SUCCESS`:
        // Covers both PATCH and POST writes - applyWriteResponsesToArray
        // distinguishes create vs. update per entry.
        applyWriteResponsesToArray(
          draft.absenceValuationMethods,
          action.result.map(({ body }) => body)
        );
        break;
      default:
      // nothing to do => immer returns the original object
    }
  });
